import React from 'react';
import classnames from 'classnames';
import style from './index.scss';
import moment from 'moment';
import {
  getDefaultMultiMapRow,
  getDefaultTableRow
} from '../../../components/TableHeader/tableRowUtils';
import {
  dateTimeFormat,
  tmDefaultPageSize
} from '../../../util/GlobalConstant';
import { getABData } from '../../../util/ABUtil';
import { convertDateInputToEpoch } from '../../../util/timezone';
import { btoaUTF8 } from '../../common/utils';

import { isEmpty } from '../../../util/lodashlike';
export const DEFAULT_ACTIVE_STATUS = -1;
export const DEFAULT_ACTIVE_SUB_STATUS = -1;

//todo: Refactor this for NS
export const statusData = [
  {
    name: 'all',
    text: 'All'
  },
  {
    name: 'open',
    text: 'Open'
  },
  {
    name: 'under_investigation',
    text: 'Under Investigation'
  },
  {
    name: 'closed',
    text: 'Closed'
  }
];

/**
 * STATUS_CODE_MAP landing page
 * @type {({name: string, text: string}|
 * {name: string, text: string}|
 * {name: string, text: string})[]}
 */

export const STATUS_CODE_MAP = [
  {
    name: 'all',
    text: 'All',
    statusCode: -1,
    isNotAnamoly: true
  },
  {
    name: 'open',
    text: 'Open',
    statusCode: 0,
    isNotAnamoly: true
  },
  {
    name: 'assigned',
    text: 'Assigned',
    statusCode: 2
  },
  {
    name: 'underInvestigation',
    text: 'Under Investigation',
    statusCode: 3
  },
  {
    name: 'pendingApproval',
    text: 'Pending Approval',
    statusCode: 4
  },
  {
    name: 'closed',
    text: 'Closed',
    statusCode: 1,
    isNotAnamoly: true
  }
];
/**
 * subStatusData
 * @type {({name: string, text: string}|{name: string, text: string}|{name: string, text: string})[]}
 */
export const subStatusData = [
  {
    name: 'all',
    text: 'All',
    statusCode: -1
  },
  {
    name: 'alert',
    text: 'Alert',
    statusCode: 0
  },
  {
    name: 'anomlay',
    text: 'Anomaly',
    statusCode: 1
  }
];

/**
 * columnData filters
 * @type {({name: string, id: string, value: string, group: [{name: string, value: string}]}|{name: string, id: string, value: string, group: [{name: string, value: string}, {name: string, value: string}]}|{name: string, id: string, value: string, group: [{name: string, value: string}]}|{name: string, id: string, value: string, group: [{name: string, value: string}, {name: string, value: string}]}|{name: string, id: string, value: string, group: [{name: string, value: string}, {name: string, value: string}]})[]}
 */
export const columnData = [
  {
    id: 'col00',
    name: 'primaryPartyKey',
    value: 'Customer ID',
    group: [
      {
        name: 'primaryPartyName',
        value: 'Customer Name'
      }
    ]
  },
  {
    id: 'col01',
    name: 'alertId',
    value: getABData('Alert / Anomaly ID'),
    group: [
      {
        name: 'alertDate',
        value: getABData('Alert / Anomaly Date')
      },
      {
        name: 'expectedCloseDate',
        value: 'Expected Closed Date'
      }
    ]
  },
  {
    id: 'col02',
    name: 'alertLevel',
    value: getABData('Alert / Anomaly Level'),
    group: [
      {
        name: 'alertScore',
        value: getABData('Alert / Anomaly Score')
      }
    ]
  },
  {
    id: 'col03',
    name: 'segmentName',
    value: 'Segment',
    group: []
  },
  {
    id: 'col04',
    name: 'accountId',
    value: 'Account Number',
    group: [
      {
        name: 'accountType',
        value: 'Account Type'
      },
      {
        name: 'accountOpenDate',
        value: 'Account Opening Date'
      }
    ]
  },
  {
    id: 'col05',
    name: 'alertStatus',
    value: getABData('Alert / Anomaly Status'),
    group: [
      {
        name: 'closureDate',
        value: getABData('Alert/Anomaly Closed Date')
      },
      {
        name: 'analystName',
        value: 'Analyst Name'
      }
    ]
  },
  {
    id: 'col06',
    name: 'rules',
    value: 'Alert Rule',
    group: []
  }
];
export const MAX_CELL_IN_ROW = 4;
/**
 * INVESTIGATION_HEADER
 * @type {({subColumns: [{name: string, key: string}],
 * name: string, key: string}|
 * {subColumns: [{name: string, key: string},
 * {name: string, key: string}], name: string, key: string}
 * |{subColumns: [{name: string, key: string}],
 * name: string, key: string}|{subColumns: [],
 * name: string, key: string}|{subColumns:
 * [{name: string, key: string}, {name: string, key: string}],
 * name: string, key: string})[]}
 */
// replace this with settings from Global Settings
export const INVESTIGATION_HEADER = [
  {
    name: 'Customer ID',
    key: 'primaryPartyKey',
    subColumns: [{ name: 'Customer Name', key: 'primaryPartyName' }]
  },
  {
    name: getABData('Alert/Anomaly ID'),
    key: 'alertId',
    subColumns: [
      { name: getABData('Alert/Anomaly Date'), key: 'alertDate' },
      { name: 'Expected Closed Date', key: 'expectedCloseDate' }
    ]
  },
  {
    name: getABData('Alert/Anomaly Level'),
    key: 'alertLevel',
    subColumns: [{ name: getABData('Alert/Anomaly Score'), key: 'alertScore' }]
  },
  {
    name: 'Segment',
    key: 'segmentName',
    subColumns: []
  },
  {
    name: 'Account Number',
    key: 'accountId',
    subColumns: [
      { name: 'Account Type', key: 'accountType' },
      { name: 'Account Opening Date', key: 'accountOpenDate' }
    ]
  },
  {
    name: getABData('Alert/Anomaly Status'),
    key: 'alertStatus',
    subColumns: [
      { name: getABData('Alert/Anomaly Closed Date'), key: 'closureDate' },
      { name: 'Analyst Name', key: 'analystName' },
      { name: '', key: 'action' }
    ]
  },
  {
    name: 'Alert Rule',
    key: 'rules',
    subColumns: []
  }
];

const InvestigationPageHeader = (props) => {
  const { userFilterSetting } = props;
  return (
    <thead className={style.pageHeader}>
      <tr>
        {INVESTIGATION_HEADER.map((eachHeader) => {
          if (eachHeader.subColumns.length === 0) {
            return (
              <th>
                <strong
                  style={{
                    padding: 3,
                    display: 'block'
                  }}>
                  {eachHeader.name}
                </strong>
                <div style={{ padding: 3 }}></div>
                <div style={{ padding: 3 }}></div>
                <div style={{ padding: 3 }}></div>
              </th>
            );
          } else {
            return (
              <th>
                <strong
                  style={{
                    padding: 3,
                    display: 'block'
                  }}>
                  {eachHeader.name}
                </strong>
                {eachHeader.subColumns.map((subColumn) => {
                  const { key } = eachHeader;
                  const isShown = userFilterSetting[key][subColumn.key];
                  if (isShown) {
                    return <div style={{ padding: 3 }}>{subColumn.name}</div>;
                  }
                  return <div style={{ padding: 3 }} />;
                })}
              </th>
            );
          }
        })}
      </tr>
    </thead>
  );
};

/**
 * getAlertsAnomalyTable
 * @param mainTable
 * @param alerts
 * @param userFilterSetting
 * @param dispatchInitialRequest
 * @returns {*}
 */
export function getAlertsAnomalyTable(
  mainTable,
  alerts,
  userFilterSetting,
  dispatchInitialRequest,
  isClickable
) {
  let userFilters = userFilterSetting;
  if (isEmpty(userFilters)) {
    userFilters = {
      primaryPartyKey: { primaryPartyName: true },
      alertId: { alertDate: true, expectedCloseDate: true },
      alertLevel: { alertScore: true },
      accountId: { accountType: true, accountOpenDate: true },
      alertStatus: { closureDate: true, analystName: true }
    };
  }
  {
    mainTable = (
      <table className={style.table_tookitaki}>
        <InvestigationPageHeader userFilterSetting={userFilters} />
        <tbody>
          {alerts.map((tableRow, idx) => {
            return (
              <tr
                className={classnames(
                  idx % 2 === 0 ? style.whiteBG : style.grayBG
                )}>
                {INVESTIGATION_HEADER.map((row) => {
                  if (row.subColumns.length === 0) {
                    return getDefaultTableRow(tableRow, row, 3);
                  } else {
                    return getDefaultMultiMapRow(
                      tableRow,
                      row,
                      userFilters,
                      dispatchInitialRequest
                    );
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
  return mainTable;
}

/**
 *
 * @param activeSubStatusNo
 * @param activeStatusNo
 * @param startDate
 * @param endDate
 * @param offset
 * @returns {{offset: *, limit: number, from: *, to: *}}
 */
export const getFilterParams = (
  activeSubStatusNo,
  activeStatusNo,
  startDate,
  endDate,
  offset,
  searchText = ''
) => {
  let params = {
    limit: tmDefaultPageSize,
    offset: offset > 0 ? offset * tmDefaultPageSize : offset,
    from: convertDateInputToEpoch(startDate.format(dateTimeFormat), false),
    to: convertDateInputToEpoch(endDate.format(dateTimeFormat), false)
  };

  let filter = [];

  if (activeSubStatusNo !== -1)
    filter.push({
      columnName: 'alertSourceId',
      logic: '=',
      value: activeSubStatusNo
    });
  if (activeStatusNo !== -1)
    filter.push({
      columnName: 'alertStatus',
      logic: '=',
      value: activeStatusNo
    });
  if (searchText !== '' && searchText.trim() !== '')
    filter.push({ columnName: 'alertId', logic: '=', value: searchText });

  params = {
    ...params,
    q: btoaUTF8(JSON.stringify({ filter }))
  };
  console.log('params :', params);
  return params;
};
